module.exports = __webpack_public_path__ + "img/003.4235782a.png";